import { Block, Flex, Typography } from '@aloft/toolkit-sui';

import { useState } from 'react';
import { useNavigate } from 'react-router';

import { MainLayout } from '../../layout/MainLayout.tsx';
import { ContactInformationContent } from './ContactInformationContent.tsx';
import { LegalLinks } from './LegalLinks.tsx';
import { MLSContent } from './MLSContent/MLSContent.tsx';
import { PersonalInformationContent } from './PersonalInformationContent.tsx';
import { Section } from './Section.tsx';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { SectionButton } from './SectionButton.tsx';
import { SubscriptionManagementContent } from './SubscriptionManagementContent.tsx';
import { AccountModuleDeps, SectionID } from './types.ts';

import './AccountModule.scss';

export const AccountModule = ({
  account,
  subscription,
  updateAccount,
  isUpdatingAccount,
}: AccountModuleDeps) => {
  const [activeSectionID, setActiveSectionID] = useState<SectionID>('personal');
  const navigate = useNavigate();

  return (
    <MainLayout
      title="Appraiser Toolkit"
      showNav={false}
      showBackButton
      onBackButtonClick={() => navigate('/')}
    >
      <Block
        className="account-module"
        width="100%"
        height="100%"
        padding="16px"
        backgroundColor="surface2"
        overflow="auto"
      >
        <Flex className="container" gap="16px">
          <Flex
            className="section-menu"
            backgroundColor="surface1"
            padding="16px 8px"
            borderRadius="4px"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Flex flexDirection="column" gap="8px">
              <Block paddingX="8px">
                <Typography variant="h2">Profile</Typography>
              </Block>
              <SectionButton
                sectionID="personal"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
              <SectionButton
                sectionID="contact"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
              <SectionButton
                sectionID="mls"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
              <SectionButton
                sectionID="subscription"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
            </Flex>
            <Flex gap="4px" paddingX="8px" marginTop="32px">
              <LegalLinks />
            </Flex>
          </Flex>
          <Block
            className="section-content"
            backgroundColor="surface1"
            padding="16px"
            borderRadius="4px"
          >
            <Section activeSectionID={activeSectionID} sectionID="personal">
              <PersonalInformationContent
                account={account}
                updateAccount={updateAccount}
                isUpdatingAccount={isUpdatingAccount}
              />
            </Section>
            <Section activeSectionID={activeSectionID} sectionID="contact">
              <ContactInformationContent
                account={account}
                updateAccount={updateAccount}
                isUpdatingAccount={isUpdatingAccount}
              />
            </Section>
            <Section activeSectionID={activeSectionID} sectionID="mls">
              <MLSContent account={account} updateAccount={updateAccount} />
            </Section>
            <Section activeSectionID={activeSectionID} sectionID="subscription">
              <SubscriptionManagementContent subscription={subscription} />
            </Section>
          </Block>
        </Flex>
      </Block>
    </MainLayout>
  );
};
